const likeBtn = $(".js-likes-btn-detail");
const favoriteBtn = $(".js-favorites-btn-detail");
const baseUrl = '/ajax/doctor/';
let requestProcessing = false;
const maxCount = 1000;

likeBtn.on('click', function (e) {
    e.preventDefault();
    makeRequest($(this), 'like');
})

favoriteBtn.on('click', function (e) {
    e.preventDefault();
    makeRequest($(this), 'favorites');
})

function makeRequest(btn, type) {
    if (requestProcessing) return;

    requestProcessing = true;
    const action = btn.attr('data-action');
    const id = btn.attr('data-idx');
    let currentCount = btn.attr('data-count');
    // склеиваем адрес запроса на основе параметров
    const url = baseUrl + `${type}.php?${action}=${id}`;

    $.ajax({
        url,
        method: 'GET',
        success: (response) => {
            if (response.success) {
                const newCount = action === 'add' ? +currentCount + 1 : +currentCount - 1;
                const newAction = action === 'add' ? 'remove' : 'add';
                $(btn.parent().find('.js-counter'))
                    .html(newCount >= maxCount ? Number((newCount / maxCount).toFixed(2))+'K' : newCount);
                btn.attr('data-action', newAction);
                btn.attr('data-count', newCount);
            }
        },
        error: () => {
            console.log('Ошибка получения данных');
        },
        complete: () => {
            requestProcessing = false;
        }
    });
}

export { makeRequest }
